import type { ThirdPartyConfigsBootstrap } from '../../../common/constants/schemas/3p-config';
import {
	convertQueryParamsToStringArray,
	getDatasourceFromId,
	parseQueryParams,
} from '../../../common/utils/query-params';
import type { QueryParams } from '../../../common/utils/query-params/types';
import { allFilters } from '../../../controllers/store/search/filters';
import { FilterUtils } from '../../../controllers/store/search/filters/utils';

type GetSearchConfigArgs = {
	cloudId: string;
	queryParams: QueryParams;
	thirdPartyConfigs: ThirdPartyConfigsBootstrap;
};

export const getSearchConfig = ({
	cloudId,
	queryParams,
	thirdPartyConfigs,
}: GetSearchConfigArgs) => {
	// Parse query params so they're typed more strongly
	const parsedQueryParams = parseQueryParams(queryParams);
	const { lastModified_lt: _, lastModified_gt: __, ...parsedQueryParamsInUse } = parsedQueryParams;
	const queryParamsWithValuesAsStringArray = convertQueryParamsToStringArray(
		parsedQueryParamsInUse,
		Object.keys(parsedQueryParams),
	);

	// Get utilities for processing query params into filters
	const { getSelectedProducts } = FilterUtils(allFilters, {});

	// Get selected products from query params
	const selectedProducts = getSelectedProducts(queryParams);

	// Get minimal filters object containing selected values based on query params
	const filters = Object.fromEntries(
		Object.entries(allFilters).map(([filterId, filter]) => {
			return [filterId, filter.queryParams.getState(queryParamsWithValuesAsStringArray, cloudId)];
		}),
	);

	// Get selected datasource
	const selectedDatasource = getDatasourceFromId(
		parsedQueryParams.datasource,
		selectedProducts[0],
		thirdPartyConfigs,
	);

	return {
		cql: parsedQueryParams.cql,
		searchQuery: parsedQueryParams.text,
		originalQuery: parsedQueryParams.originalQuery,
		filters,
		selectedProducts,
		selectedDatasource,
	};
};
